import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import ShapeChange from "../ShapeChange";
import DrawingPrepare from "../DrawingPrepare";
import ModelSelecter, { MODEL_SELECT_OPTIONS } from "../buttons/ModelSelecter";

// 形状変更ガイドは原則すべての誤りを扱えるため、演習と同じ13モデルを切り替え可能にする
const SHAPE_DEMO_VALUES = [
  'model1', 'model2', 'model3', 'model4', 'model5', 'model6', 'model7', 'model8',
  'cube_model1', 'cube_model2', 'cube_model3', 'cube_model4', 'cube_model5',
];
const SHAPE_DEMO_OPTIONS = MODEL_SELECT_OPTIONS.filter((o) => SHAPE_DEMO_VALUES.includes(o.value));

function Suggest2() {
  const location = useLocation();
  // 旧フロー（LearnerMain）互換：route state の errorScore を初期モデルに使う
  const incomingErrorScore = location.state?.errorScore;
  const [errorGlbPath, setErrorGlbPath] = useState(incomingErrorScore ? `model${incomingErrorScore}` : 'model1');

  const [drawingImages, setDrawingImages] = useState([null, null, null]);
  const [imagesLoading, setImagesLoading] = useState(true);

  const handleImagesReady = (images) => {
    setDrawingImages(images);
    setImagesLoading(false);
  };

  // モデルを切り替えたらデッサン風画像の生成からやり直す
  const handleModelChange = (glbPath) => {
    setImagesLoading(true);
    setDrawingImages([null, null, null]);
    setErrorGlbPath(glbPath);
  };

  return (
    <div className="page">
      <h1 className="heading-hero mb-6">形状変更ガイドデモ</h1>

      <div className="row-center mb-4">
        <ModelSelecter
          errorGlbPath={errorGlbPath}
          setErrorGlbPath={handleModelChange}
          options={SHAPE_DEMO_OPTIONS}
        />
      </div>

      {/* 画像準備を先に実行（key でモデルごとに作り直す） */}
      <DrawingPrepare key={`prepare-${errorGlbPath}`} errorGlbPath={errorGlbPath} onImagesReady={handleImagesReady} />

      {/* 画像準備が完了してから ShapeChange を表示。
          onComplete を渡さない＝デモ表示。説明シートは演習と同じように出るが、
          【決定】を押しても何も起こらず実験ログも送らない */}
      {imagesLoading ? (
        <div className="w-full h-48 flex items-center justify-center">
          <p>画像を準備しています...</p>
        </div>
      ) : (
        <ShapeChange
          key={`shape-${errorGlbPath}`}
          drawingImages={drawingImages}
          imagesLoading={imagesLoading}
          errorGlbPath={errorGlbPath}
        />
      )}
    </div>
  );
}

export default Suggest2;
